import { render, staticRenderFns } from "./BaseOptions.vue?vue&type=template&id=27649491&scoped=true"
import script from "./BaseOptions.vue?vue&type=script&lang=js"
export * from "./BaseOptions.vue?vue&type=script&lang=js"
import style0 from "./BaseOptions.vue?vue&type=style&index=0&id=27649491&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27649491",
  null
  
)

export default component.exports